import { Component, Input, OnInit } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { DishServices } from "../../../services";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { AIServices } from "../../../../services/aiServices";

@Component({
    selector: 'page-dish-partial-name',
    templateUrl: 'dish-partial-name.html',
})
export class DishPartialNamePage implements OnInit {
    @Input() update_state;

    public form: FormGroup;
    show_list: boolean = false;
    filteredDishes: any;
    es: any;
    en: any;
    it: any;
    de: any;
    fr: any;
    ca: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices,
        public http: HttpClient,
        private translateService: TranslateService,
        public fb: FormBuilder,
        public alertCtrl: AlertController,
        public loadingCtrl: LoadingController,
        public aiServices: AIServices) {

    }

    ngOnInit() {
        //init
        if (this.update_state) {
            this.es = this.dishServices.form.value.name_es;
            this.en = this.dishServices.form.value.name_en;
            this.fr = this.dishServices.form.value.name_fr;
            this.it = this.dishServices.form.value.name_it;
            this.de = this.dishServices.form.value.name_de;
            this.ca = this.dishServices.form.value.name_ca;

            /*this.dishServices.form.value.name_es = this.es;
            this.dishServices.form.value.name_en = this.en;
            this.dishServices.form.value.name_fr = this.fr;
            this.dishServices.form.value.name_it = this.it;
            this.dishServices.form.value.name_de = this.de;
            this.dishServices.form.value.name_ca = this.ca;*/
        }


        if(this.globals.checkLimitsByLicense('dishes', 'langs')){
            this.dishServices.form
            .get(this.returnName())
            .valueChanges
            .pipe(
                debounceTime(300),
            )
            .subscribe(data => {
                if (this.returnNameContent() != '') {
                    this.search(this.returnNameContent(), this.globals.restaurant.lang).subscribe(response => {
                        this.filteredDishes = response
                        this.show_list = true;
                    })
                }

            })
        }
    }

    dishes: any;
    search(term, lang) {
        if (this.globals.checkLimitsByLicense('dishes', 'langs')) {
            return this.http.post(this.globals.api_path + 'dictionary/consult_dish', {
                lang: lang,
                dish: term,
            }, {}).map(res => {
                return res;
            })
        }
    }

    //selecciona un plato, autocompleta
    autocomplete(listItem) {
        //preguntar
        let alert = this.alertCtrl.create({
            title: this.translateService.instant('instant-traducir-plato'),
            message: this.translateService.instant('instant-traducir-plato-message'),
            buttons: [
                {
                    text: this.translateService.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                        /*this.es = listItem['es'];
                        this.dishServices.form.value.name_es = this.es;*/

                        //limpia
                        this.show_list = false;
                        this.filteredDishes = [];
                    }
                },
                {
                    text: this.translateService.instant('general-si'),
                    handler: () => {
                        //autocompleta

                        /*this.dishServices.form.get('name_es').setValue(listItem['es']);
                        this.dishServices.form.get('name_en').setValue(listItem['en']);
                        this.dishServices.form.get('name_fr').setValue(listItem['fr']);
                        this.dishServices.form.get('name_de').setValue(listItem['de']);
                        this.dishServices.form.get('name_it').setValue(listItem['it']);
                        this.dishServices.form.get('name_ca').setValue(listItem['ca']);*/

                        this.es = listItem['es'][0].toUpperCase() + listItem['es'].substring(1);
                        this.en = listItem['en'][0].toUpperCase() + listItem['en'].substring(1);
                        this.fr = listItem['fr'][0].toUpperCase() + listItem['fr'].substring(1);
                        this.de = listItem['de'][0].toUpperCase() + listItem['de'].substring(1);
                        this.it = listItem['it'][0].toUpperCase() + listItem['it'].substring(1);
                        this.ca = listItem['ca'][0].toUpperCase() + listItem['ca'].substring(1);

                        this.dishServices.form.patchValue({
                            name_es: this.es,
                            name_en: this.en,
                            name_fr: this.fr,
                            name_it: this.it,
                            name_de: this.de,
                            name_ca: this.ca
                        });

                        //limpia
                        this.show_list = false;
                        this.filteredDishes = [];
                    }
                }
            ]
        });
        alert.present();

    }

    returnName() {
        switch (this.globals.restaurant.lang) {
            case 'es': {
                return 'name_es';
            }
            case 'en': {
                return 'name_en';
            }
            case 'fr': {
                return 'name_fr';
            }
            case 'de': {
                return 'name_de';
            }
            case 'it': {
                return 'name_it';
            }
            case 'ca': {
                return 'name_ca';
            }
        }
    }

    returnNameContent() {
        switch (this.globals.restaurant.lang) {
            case 'es': {
                return this.dishServices.form.value.name_es;
            }
            case 'en': {
                return this.dishServices.form.value.name_en;
            }
            case 'fr': {
                return this.dishServices.form.value.name_fr;
            }
            case 'de': {
                return this.dishServices.form.value.name_de;
            }
            case 'it': {
                return this.dishServices.form.value.name_it;
            }
            case 'ca': {
                return this.dishServices.form.value.name_ca;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-name/dish-partial-name/dish-partial-name.ts